(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["recipe-banner-a"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    if (window.EpeiosRecipeBannerA) {
      window.EpeiosRecipeBannerA.refresh();
      return;
    }
    const selector = '[data-recipe-banner-a]';
    const handles = new Set(['foelem_chef', 'cp247a', 'airfryer_epao248', 'hug', 'co800', 'quickshot', 'foelem_mocca']);
    const bound = new WeakSet();
    const viewed = new WeakSet();
    const visible = new Set();
    const seen = new Set();
    const diagnostics = [];
    const PUBLICATION_CONFIG = Object.freeze({"enabled":false,"environment":"off","preview_theme_id":null,"preview_host":null,"production_verified":false});
    const dwellTimers = new Map();
    const bannerDesktop = window.matchMedia('(min-width: 1000px)');
    let bannerMount = null;
    let pending = false;
    const handle = () => {
      const match = window.location.pathname.match(/^\/products\/([^/]+)\/?$/);
      return match && handles.has(match[1]) ? match[1] : null;
    };
    const previewIdentityAllowed = () => {
      const config = PUBLICATION_CONFIG;
      const url = new URL(window.location.href);
      const sharedHost = typeof config.preview_host === 'string' && /^[a-z0-9-]+\.shopifypreview\.com$/.test(config.preview_host);
      if (config.enabled !== true || config.environment !== 'qa' || typeof config.preview_theme_id !== 'string' || !/^\d+$/.test(config.preview_theme_id)) return false;
      if ((!sharedHost && config.preview_host !== 'epeios.jp') || url.origin !== `https://${config.preview_host}`) return false;
      const qa = url.searchParams.getAll('qa');
      const themes = url.searchParams.getAll('preview_theme_id');
      if (qa.length !== 1 || qa[0] !== '1' || themes.length > 1) return false;
      return themes.length === 1 ? themes[0] === config.preview_theme_id : sharedHost;
    };
    const suppressed = root => {
      const isolatedPreview = previewIdentityAllowed() && !window.Shopify?.designMode;
      if (isolatedPreview) return false;
      if (root.dataset.shopifyPreview === 'true' || window.Shopify?.designMode || window.Shopify?.visualPreviewMode) return true;
      if (window.location.hostname !== 'epeios.jp') return true;
      const params = new URLSearchParams(window.location.search);
      return [...params.keys()].some(key => /preview|^qa$|^test$|^_ab$|^_fd$|^_sc$|^ptengine|^pt_preview/i.test(key));
    };
    const consent = () => {
      try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
      catch { return false; }
    };
    const publishBanner = (root, action, position) => {
      if (PUBLICATION_CONFIG.enabled !== true || !consent() || suppressed(root)) return;
      if (PUBLICATION_CONFIG.environment === 'qa') {
        if (!previewIdentityAllowed()) return;
      }
      if (PUBLICATION_CONFIG.environment === 'production' && PUBLICATION_CONFIG.production_verified !== true) return;
      if (!['qa', 'production'].includes(PUBLICATION_CONFIG.environment) || typeof window.Shopify?.analytics?.publish !== 'function' || typeof window.crypto?.randomUUID !== 'function') return;
      const eventName = action === 'view' ? 'epeios_banner_a:view' : 'epeios_banner_a:click';
      const payload = {
        schema_version: 1, event_name: eventName, event_id: window.crypto.randomUUID(), revision: 'native-a-20260909-r1',
        product_handle: handle(), placement: root.dataset.recipePlacement, position, destination: '/blogs/recipe',
        environment: PUBLICATION_CONFIG.environment, analytics_consent: true,
        device: window.innerWidth < 750 ? 'mobile' : window.innerWidth < 1000 ? 'tablet' : 'desktop', observed_at: new Date().toISOString()
      };
      try { Promise.resolve(window.Shopify.analytics.publish(eventName, payload)).catch(() => {}); } catch {}
    };
    const record = (root, action, position = '0') => {
      if (!root.isConnected || root.dataset.productHandle !== handle() || suppressed(root) || !consent()) return;
      const key = `${handle()}:${action}:${position}`;
      if (seen.has(key)) return;
      seen.add(key);
      const detail = Object.freeze({ event: `recipe_banner_${action}`, product_handle: handle(), variant: 'A', revision: 'native-a-20260909-r1', position, destination: '/blogs/recipe', transport: 'none', delivery: 'unverified' });
      diagnostics.push(detail);
      if (diagnostics.length > 32) diagnostics.shift();
      root.dispatchEvent(new CustomEvent('epeios:recipe-banner-diagnostic', { detail, bubbles: false }));
      publishBanner(root, action, position);
    };
    const cancelDwell = root => {
      clearTimeout(dwellTimers.get(root));
      dwellTimers.delete(root);
    };
    const startDwell = root => {
      if (dwellTimers.has(root) || !root.isConnected || document.hidden || !consent() || suppressed(root)) return;
      dwellTimers.set(root, setTimeout(() => {
        dwellTimers.delete(root);
        if (visible.has(root) && !document.hidden) record(root, 'view');
      }, 1000));
    };
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= .5) { visible.add(entry.target); startDwell(entry.target); }
        else { visible.delete(entry.target); cancelDwell(entry.target); }
      }
    }, { threshold: [.5] }) : null;
    function mountResponsiveBanner(root, current) {
      const product = root.closest('.product') || (bannerMount?.root === root && bannerMount.product.isConnected ? bannerMount.product : null);
      if (!product || !product.closest('product-rerender')) return false;
      if (bannerMount?.root !== root || bannerMount.product !== product) {
        if (bannerMount) {
          bannerMount.home.remove();
        }
        const home = document.createComment('recipe-banner-responsive-home');
        root.before(home);
        bannerMount = { root, product, home };
      }
      const state = bannerMount;
      const widget = product.querySelector(current === 'hug' ? '.epr-rec-wrapper' : '.chef-cro-complements');
      if (bannerDesktop.matches) {
        if (product.nextElementSibling !== root) product.after(root);
      } else {
        if (widget) {
          if (root.nextElementSibling !== widget) widget.before(root);
        } else if (state.home.isConnected && state.home.nextElementSibling !== root) {
          state.home.after(root);
        }
      }
      root.dataset.recipePlacement = !bannerDesktop.matches && widget ? 'before-recommendations' : 'after-product-root';
      return true;
    }
    function mountMocca(root) {
      const product = document.querySelector('product-rerender[id^="product-info-"] .product');
      if (!product || root.contains(product)) return false;
      if (product.nextElementSibling !== root) product.after(root);
      root.dataset.recipePlacement = 'after-product-root';
      return true;
    }
    function refresh() {
      for (const item of visible) if (!item.isConnected) { visible.delete(item); cancelDwell(item); observer?.unobserve(item); }
      const current = handle();
      if (!current) return;
      const roots = [...document.querySelectorAll(selector)].filter(root => root.dataset.productHandle === current);
      const responsive = current === 'foelem_chef' || current === 'hug';
      const root = responsive ? roots.find(item => item.closest('.product')) || roots[0] : roots[0];
      if (!root) return;
      roots.filter(item => item !== root).forEach(duplicate => { visible.delete(duplicate); cancelDwell(duplicate); observer?.unobserve(duplicate); duplicate.remove(); });
      const bannerMounted = (responsive && mountResponsiveBanner(root, current)) || (current === 'foelem_mocca' && mountMocca(root));
      if (!bannerMounted) {
      const anchors = [...document.querySelectorAll('.chef-cro-complements, .epr-rec-wrapper, .epr-rel-tabs-wrapper')]
        .filter(widget => !root.contains(widget) && !widget.contains(root))
        .map(widget => widget.closest('.shopify-section--custom-liquid[id^="shopify-section-"]') || widget)
        .filter(module => !root.contains(module));
      const anchor = anchors.reduce((first, module) => !first || (module.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING) ? module : first, null);
      if (anchor) {
        if (root.nextElementSibling !== anchor) anchor.before(root);
        root.dataset.recipePlacement = 'before-recommendations';
      } else {
        const productRoot = document.querySelector('product-rerender[id^="product-info-"]') || document.querySelector('product-rerender') || document.querySelector('.shopify-section--main-product');
        if (productRoot && !root.contains(productRoot) && productRoot.nextElementSibling !== root) productRoot.after(root);
        root.dataset.recipePlacement = 'after-product-root';
      }
      }
      if (!bound.has(root)) {
        bound.add(root);
        root.addEventListener('click', event => {
          const link = event.target.closest?.('[data-recipe-action]');
          if (link && root.contains(link)) record(root, 'click', `${link.dataset.recipeAction}:${link.dataset.recipePosition}`);
        });
      }
      if (observer && !viewed.has(root)) { viewed.add(root); observer.observe(root); }
    }
    const schedule = () => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => { pending = false; refresh(); });
    };
    window.EpeiosRecipeBannerA = Object.freeze({ refresh, diagnostics: () => diagnostics.map(item => ({ ...item })), transport: 'none' });
    bannerDesktop.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visitorConsentCollected', () => {
      if (!consent()) { diagnostics.length = 0; for (const root of dwellTimers.keys()) cancelDwell(root); return; }
      for (const root of visible) startDwell(root);
    });
    document.addEventListener('visibilitychange', () => {
      for (const root of dwellTimers.keys()) cancelDwell(root);
      if (!document.hidden) for (const root of visible) startDwell(root);
    });
    const mount = () => {
      refresh();
      const scope = document.querySelector('#main') || document.querySelector('main') || document.querySelector('.shopify-section--main-product') || document.querySelector(selector)?.parentElement;
      if (scope) new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
    else mount();
  })();
  } catch(e) { console.error(e); }
})();

})();
